import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_MY_DRAFTS ({ commit }) {
    const query = `query antragDrafts($order_by: AntragDraftSort) {
      antragDrafts(order_by: $order_by) {
        nodes {
          antraegeEntwuerfeId
          antragErstellt
          antragErstelltDatum
          createdDate
          jsonPayload
          userId
          draftKey
          gesuchsartBezeichnung
          lastUpdateDate
        }
      }
    }`

    const variables = {
      order_by: {
        createdDate: 'DESC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_DRAFTS', data.data.antragDrafts.nodes)
    }

    return data
  },
  async GET_LATEST_UPDATED_DRAFT ({ commit }) {
    const query = `query antragDrafts($order_by: AntragDraftSort, $first: PaginationAmount) {
      antragDrafts(order_by: $order_by first: $first) {
        nodes {
          antraegeEntwuerfeId
          antragErstellt
          antragErstelltDatum
          createdDate
          jsonPayload
          userId
          gemeindeId
          draftKey
          gesuchsartBezeichnung
          lastUpdateDate
        }
      }
    }`

    const variables = {
      order_by: {
        lastUpdateDate: 'DESC'
      },
      first: 1
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_LATEST_UPDATED_DRAFT', data.data.antragDrafts.nodes[0])
    }

    return data
  },
  async GET_DRAFT_BY_ID ({ rootState, commit }, draftId) {
    const query = `query antragDraft($draftId: Int!) {
      antragDraft(draftId: $draftId) {
        antraegeEntwuerfeId
        antragErstellt
        antragErstelltDatum
        createdDate
        jsonPayload
        userId
        gemeindeId
        draftKey
        gesuchsartBezeichnung
        lastUpdateDate
      }
    }`

    const variables = {
      draftId: Number(draftId)
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const json = JSON.parse(data.data.antragDraft.jsonPayload)

      const {
        applicationPropertyType,
        gesuchCode,
        gemeindeId,
        applictionTypeName,
        personId,
        personContactId,
        propertyId,
        correspondence
      } = json

      if (applicationPropertyType) {
        commit('application/SET_APPLICATION_PROPERTY_ID', propertyId, { root: true })
        commit('application/SET_APPLICATION_PROPERTY_TYPE', gesuchCode, { root: true })
        commit('application/SET_APPLICATION_COMMUNITY', gemeindeId, { root: true })
        commit('application/SET_APPLICATION_PROPERTY_FINAL', {}, { root: true })
      } else {
        commit('application/SET_APPLICATION_COMMUNITY_ADVANCED', gemeindeId, { root: true })
        commit('application/SET_APPLICATION_ADVANCED_TYPE', gesuchCode, { root: true })
        commit('application/SET_APPLICATION_ADVANCED_FINAL', {}, { root: true })
      }

      commit('application/SET_APPLICATION_TYPE_NAME', applictionTypeName, { root: true })
      commit('application/SET_APPLICATION_PERSON_ID', personId, { root: true })
      commit('application/SET_APPLICATION_PERSON_CONTACT_ID', personContactId, { root: true })
      commit('application/SET_CORRESPONDENCE', correspondence, { root: true })

      commit('application/SET_UPDATE_FORMFIELD_JSON', json, { root: true })
      commit('application/SET_MODAL_SHOW', {
        boolShow: true,
        modalMethod: 'bearbeiten',
        draftId,
        tabName: 'gesuch'
      }, { root: true })
    }

    return data
  },
  async SAVE_DRAFT ({ rootState, state, commit, dispatch }) {
    const {
      finalCommunityId,
      finalApplicationType,
      propertyId,
      applicationPropertyType,
      applictionTypeName,
      correspondence
    } = rootState.application.createApplication

    const {
      personId,
      personContactId
    } = rootState.application.createApplication.formData

    const query = `mutation antragDraftCreate($input: AntragDraftCreateInput!) {
      antragDraftCreate(input: $input) {
        antraegeEntwuerfeId
        antragErstellt
        antragErstelltDatum
        createdDate
        jsonPayload
        userId
        gemeindeId
        draftKey
        gesuchsartBezeichnung
        lastUpdateDate
      }
    }`

    const { formData } = rootState.application.createApplication

    const gesuch = Object.keys(formData.gesuch).map(key => {
      const value = formData.gesuch[key]
      return { name: key, value: value }
    })

    const variables = {
      input: {
        eigentuemerUserPersonId: personId,
        kontaktPersonUserPersonId: personContactId,
        liegenschaftId: propertyId,
        jsonPayload: JSON.stringify({
          gemeindeId: finalCommunityId,
          gesuchCode: finalApplicationType,
          applicationPropertyType,
          applictionTypeName,
          personId,
          personContactId,
          propertyId,
          gesuch,
          correspondence
        })
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_DRAFT', data.data.antragDraftCreate)
      commit('SET_LATEST_UPDATED_DRAFT', data.data.antragDraftCreate)
      commit('application/RESET_APPLICATION_FORM', {}, { root: true })
    }

    return data
  },
  async UPDATE_DRAFT ({ rootState, commit }, draftId) {
    const {
      finalCommunityId,
      finalApplicationType,
      propertyId,
      applicationPropertyType,
      applictionTypeName,
      correspondence
    } = rootState.application.createApplication

    const {
      personId,
      personContactId
    } = rootState.application.createApplication.formData

    const query = `mutation antragDraftUpdate($input: AntragDraftUpdateInput!) {
      antragDraftUpdate(input: $input) {
        antraegeEntwuerfeId
        antragErstellt
        antragErstelltDatum
        createdDate
        gemeindeId
        gesuchCode
        gesuchsartBezeichnung
        lastUpdateDate
      }
    }`

    const { formData } = rootState.application.createApplication

    const gesuch = Object.keys(formData.gesuch).map(key => {
      const value = formData.gesuch[key]
      return { name: key, value: value }
    })

    const variables = {
      input: {
        antraegeEntwuerfeId: Number(draftId),
        eigentuemerUserPersonId: personId,
        kontaktPersonUserPersonId: personContactId,
        liegenschaftId: propertyId,
        jsonPayload: JSON.stringify({
          gemeindeId: finalCommunityId,
          gesuchCode: finalApplicationType,
          applicationPropertyType,
          applictionTypeName,
          personId,
          personContactId,
          propertyId,
          gesuch,
          correspondence
        })
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('UPDATE_DRAFT', data.data.antragDraftUpdate)
      commit('SET_LATEST_UPDATED_DRAFT', data.data.antragDraftUpdate)
      commit('application/RESET_APPLICATION_FORM', {}, { root: true })
    }

    return data
  },
  async DELETE_DRAFT ({ commit }, draftId) {
    const query = `mutation antragDraftDelete($input: AntragDraftDeleteInput!) {
      antragDraftDelete(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        antraegeEntwuerfeId: draftId
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('DELETE_DRAFT', draftId)
    }

    return data
  }
}
